// Produktkachel (iso_list_Liste.html5, dasselbe Markup in iso_list_slider.html5)
//
// Zweites Produktbild beim Darueberfahren: So sieht man Vorder- und
// Rueckseite, ohne die Kachel zu verlassen. Geladen wird es erst beim
// ersten Hover, auf dem Handy also gar nicht.

const zweitBildLaden = (bild) => {
    if (bild.dataset.fnGeladen) {
        return;
    }

    bild.dataset.fnGeladen = '1';
    bild.addEventListener('load', () => {
        bild.classList.add('ist-bereit');
        // Erst wenn das zweite Bild wirklich da ist, darf das erste
        // weggeblendet werden - sonst sieht man kurz nur die graue Flaeche.
        if (bild.parentElement) {
            bild.parentElement.classList.add('hat-zweitbild');
        }
    }, { once: true });
    bild.src = bild.getAttribute('data-fn-zweit');
};

document.addEventListener('mouseover', (ereignis) => {
    const behaelter = ereignis.target.closest ? ereignis.target.closest('.image_container') : null;

    if (!behaelter) {
        return;
    }

    const zweit = behaelter.querySelector('.fn-kachel-zweit');

    if (zweit) {
        zweitBildLaden(zweit);
    }
}, { passive: true });
